import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {Box, Button, Flex} from '@salesforce/retail-react-app/app/components/shared/ui'

// TODO: refactor — legacy `optimizely/layouts/productSizeGuideBlockLayout` removed in GDI cleanup, awaiting PDP/PLP refactor
const ProductSizeGuideBlockLayout = () => null
import {LeftArrow} from '../../icons'

const QuickViewSizeChart = ({optimizelyContent, category = [], onBack}) => {
    const categoryId = category?.[2]?.id

    const content = useMemo(() => {
        return optimizelyContent?.items?.[0]?.MainRegion?.[0]?.ContentLink?.Expanded
    }, [optimizelyContent])

    return (
        <Flex width="100%" height="100%" flexDirection="column">
            <Box px={4} py={4}>
                <Button
                    variant="unstyled"
                    onClick={onBack}
                    display="flex"
                    alignItems="center"
                    height={'24px'}
                    width={'24px'}
                    minW={'auto'}
                    aria-label="Back to quick view"
                >
                    <LeftArrow />
                </Button>
            </Box>
            <Box flex="1" overflowY="auto" px={4} pb={4}>
                <ProductSizeGuideBlockLayout
                    content={content}
                    categoryId={categoryId}
                    showAllCharts={false}
                    showDropdown={false}
                    containerProps={{
                        padding: '0',
                        margin: '0'
                    }}
                    titleProps={{
                        display: 'none'
                    }}
                />
            </Box>
        </Flex>
    )
}

QuickViewSizeChart.propTypes = {
    optimizelyContent: PropTypes.object,
    category: PropTypes.array,
    onBack: PropTypes.func
}

export default QuickViewSizeChart
